import React from "react";

const VerificationHistoryModal = ({ isOpen, onClose, history, formatTime }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/40 backdrop-blur-[2px] p-4">
            <div className="relative w-full max-w-[600px] animate-[slideIn_0.3s_cubic-bezier(0.16,1,0.3,1)]">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute -top-5 -right-5 w-[42px] h-[42px] bg-[#00ADEF] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform z-[2001]"
                >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L13 13M1 13L13 1" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                    </svg>
                </button>

                {/* Main Content Area */}
                <div
                    className="bg-white rounded-[24px] p-6 sm:p-8 w-full shadow-[0px_20px_60px_rgba(0,0,0,0.15)] max-h-[80vh] flex flex-col"
                >
                    <h2 className="text-[24px] font-[600] text-[#303030] mb-6 font-poppins">Verification History</h2>

                    <div className="flex-1 overflow-y-auto pr-2 custom-scrollbar" style={{ scrollbarWidth: 'none' }}>
                        <div className="divide-y divide-[#F2F4F7]">
                            {history && history.length > 0 ? (
                                history.map((item, index) => (
                                    <div key={index} className="flex items-center justify-between py-4 hover:bg-[#F9FAFB] transition-colors rounded-lg px-2">
                                        <div className="flex items-center gap-4">
                                            <div className={`w-[40px] h-[40px] rounded-full flex items-center justify-center shrink-0 ${(item?.status === 'success' || item?.status === 'valid') ? 'bg-[#E7F9F0]' : 'bg-[#FFF2F2]'}`}>
                                                {(item?.status === 'success' || item?.status === 'valid') ? (
                                                    <svg width="16" height="12" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M18.3333 1.66663L6.66667 13.3333L1.66667 8.33329" stroke="#20C997" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                ) : (
                                                    <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="9" cy="9" r="8" stroke="#FF4D4F" strokeWidth="2" />
                                                        <path d="M9 6V9" stroke="#FF4D4F" strokeWidth="2" strokeLinecap="round" />
                                                        <path d="M9 12H9.01" stroke="#FF4D4F" strokeWidth="2.5" strokeLinecap="round" />
                                                    </svg>
                                                )}
                                            </div>
                                            <div className="flex flex-col">
                                                <p className="text-[15px] font-[600] text-[#303030] font-poppins uppercase tracking-[0.5px]">
                                                    {item?.code || "CODE-UNKNOWN"}
                                                </p>
                                                <p className="text-[12px] text-[#8C8C8C] font-poppins">
                                                    {(!item?.memberName || item?.memberName === "Unknown") ? "Unclaimed" : `Redeemed by ${item.memberName}`} • {formatTime(item?.createdAt)}
                                                </p>
                                            </div>
                                        </div>
                                        <div className={`px-3 py-1 rounded-full text-[10px] font-[700] font-poppins uppercase tracking-[0.5px] ${(item?.status === 'success' || item?.status === 'valid') ? 'bg-[#E7F9F0] text-[#20C997]' : 'bg-[#FFF2F2] text-[#FF4D4F]'}`}>
                                            {(item?.status === 'success' || item?.status === 'valid') ? 'VALID' : 'INVALID'}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className="text-center py-10 text-[#8C8C8C] font-poppins">No history found.</p>
                            )}
                        </div>
                    </div>

                    <button
                        onClick={onClose}
                        className="mt-6 w-full h-[50px] bg-[#F5F5F5] hover:bg-[#EEEEEE] text-[#303030] rounded-[12px] text-[16px] font-[600] font-poppins transition-all"
                    >
                        Close
                    </button>
                </div>
            </div>
            <style>{`
                @keyframes slideIn {
                    from { opacity: 0; transform: translateY(20px) scale(0.95); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }
                .custom-scrollbar::-webkit-scrollbar {
                    display: none;
                }
            `}</style>
        </div>
    );
};

export default VerificationHistoryModal;
